// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Rate\ApiRate.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';
import { Price, PriceData, PriceOptions } from 'data/models/Price';
import { StandardItem, StandardItemData, StandardItemOptions } from 'data/models/StandardItem';
import { RateType } from 'server/enums/RateType';

// RateData is the class that Rate serializes to/from
export interface RateData {
    Id : number;
	
    BillingSystem : BillingSystemData | null;
    BillingSystemId : number;
    StandardItem : StandardItemData | null;
    StandardItemId : number;
	
    MaxQuantity : number | null;
    MinQuantity : number | null;
    Price : PriceData;
    Quantity : MeasurementData;
    Type : RateType;
}

// RateOptions is the class which may be passed to the Rate constructor to define optional initial data values
export interface RateOptions {
    Id : number;
	
    BillingSystem? : BillingSystemOptions | null;
    BillingSystemId? : number;
    StandardItem? : StandardItemOptions | null;
    StandardItemId? : number;
	
    MaxQuantity? : number | null;
    MinQuantity? : number | null;
    Price? : PriceOptions;
    Quantity? : MeasurementOptions;
    Type? : RateType;
}

export class Rate {
    public Id : DataSignal<number>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public BillingSystemId : DataSignal<number>;
    public StandardItem : DataSignal<StandardItem | null>;
    public StandardItemId : DataSignal<number>;
	
    public MaxQuantity : DataSignal<number | null>;
    public MinQuantity : DataSignal<number | null>;
    public Price : Price;
    public Quantity : Measurement;
    public Type : DataSignal<RateType>;

    constructor();
    constructor(data : RateOptions);
    constructor(data: RateOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.BillingSystemId = jsonableObservable(S.value<number>(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.StandardItem = S.value<StandardItem | null>(null);
        this.StandardItemId = jsonableObservable(S.value<number>(data && data.StandardItemId !== undefined ? data.StandardItemId : 0));
	    
        this.MaxQuantity = jsonableObservable(S.value<number | null>(data && data.MaxQuantity !== undefined ? data.MaxQuantity : null));
        this.MinQuantity = jsonableObservable(S.value<number | null>(data && data.MinQuantity !== undefined ? data.MinQuantity : null));
        this.Price = data && data.Price !== undefined ? new Price(data.Price) : new Price();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement(data.Quantity) : new Measurement();
        this.Type = jsonableObservable(S.value<RateType>(data && data.Type !== undefined ? data.Type : 0));
    }

    static key(obj : Rate) {
        return obj.Id();
    }
    
    static dataKey(obj : RateOptions) {
        return obj.Id;
    }

    static update(obj : Rate, data : RateOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillingSystemId !== undefined) obj.BillingSystemId(data.BillingSystemId);
            if (data.StandardItemId !== undefined) obj.StandardItemId(data.StandardItemId);
	        
            if (data.MaxQuantity !== undefined) obj.MaxQuantity(data.MaxQuantity);
            if (data.MinQuantity !== undefined) obj.MinQuantity(data.MinQuantity);
            if (data.Price !== undefined) Price.update(obj.Price, data.Price);
            if (data.Quantity !== undefined) Measurement.update(obj.Quantity, data.Quantity);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Rate.ts